import { render, staticRenderFns } from "./callContainerDialog.vue?vue&type=template&id=37e745f2&scoped=true&"
import script from "./callContainerDialog.vue?vue&type=script&lang=js&"
export * from "./callContainerDialog.vue?vue&type=script&lang=js&"
import style0 from "./callContainerDialog.vue?vue&type=style&index=0&id=37e745f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e745f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37e745f2')) {
      api.createRecord('37e745f2', component.options)
    } else {
      api.reload('37e745f2', component.options)
    }
    module.hot.accept("./callContainerDialog.vue?vue&type=template&id=37e745f2&scoped=true&", function () {
      api.rerender('37e745f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/RailwayExport/components/booking/callContainerDialog.vue"
export default component.exports